export const buildEmailPreferencesOrEmpty = (data) => {
    var _a, _b, _c, _d, _e, _f;
    if (!data) {
        return {
            isEmailPreferencesSet: false,
            email: null,
            isSubPremiumContent: false,
            isSubNewsletter: false,
            isSubEvents: false,
            isSubBlogs: false,
        };
    }
    return {
        isEmailPreferencesSet: (_a = data.isEmailPreferencesSet) !== null && _a !== void 0 ? _a : false,
        email: (_b = data.email) !== null && _b !== void 0 ? _b : null,
        isSubPremiumContent: (_c = data.isSubPremiumContent) !== null && _c !== void 0 ? _c : false,
        isSubNewsletter: (_d = data.isSubNewsletter) !== null && _d !== void 0 ? _d : false,
        isSubEvents: (_e = data.isSubEvents) !== null && _e !== void 0 ? _e : false,
        isSubBlogs: (_f = data.isSubBlogs) !== null && _f !== void 0 ? _f : false,
    };
};
